import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useInformationBar } from '../../../../hooks';
import styles from './informationBar.module.scss';

const InformationBar = ({ containerClass, style }) => {
  const { content } = useInformationBar();
  if (content == null) {
    return null;
  }
  return (
    <div className={classNames(styles.wrapper, containerClass)} style={style} role="status">
      {content}
    </div>
  );
};

InformationBar.propTypes = {
  containerClass: PropTypes.string,
  style: PropTypes.shape({}),
};
InformationBar.defaultProps = {
  containerClass: undefined,
  style: undefined,
};
export default memo(InformationBar);
